import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_LEAD_PROFILE_STICKY_COLUMNS,
  UPDATE_LEAD_PROFILE_STICKY_COLUMNS,
} from "./actionTypes"

import {
  getLeadProfileStickyColumnsSuccess,
  getLeadProfileStickyColumnsError,
  updateLeadProfileStickyColumnsSuccess,
  updateLeadProfileStickyColumnsError
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* ongetLeadProfileStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_lead_profiles`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getLeadProfileStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getLeadProfileStickyColumnsError(error))
  }
}

function* onupdateLeadProfileStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_lead_profiles/${action?.payload?.user_column_preference_profile?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadProfileStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateLeadProfileStickyColumnsError(error))
  }
}

function* userLeadProfileColumnPreferenceSaga() {
  yield takeEvery(GET_LEAD_PROFILE_STICKY_COLUMNS, ongetLeadProfileStickyColumns)
  yield takeEvery(UPDATE_LEAD_PROFILE_STICKY_COLUMNS, onupdateLeadProfileStickyColumns)
}

export default userLeadProfileColumnPreferenceSaga;
